/* eslint-disable react/no-this-in-sfc */
import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import _isArray from 'lodash/isArray';
import { ErrorToast } from '../utils/Utils';

const useStyles = makeStyles({
  multiSearch: {
    width: (props) => props.width || '100%',
    background: '#f4f4f4',
    border: '1px solid #000000',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  ellipsisMessage: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: (props) => props.labelWidth || '100%',
    whiteSpace: 'nowrap',
    display: 'block',
  },
});

const CustomMultiSelectAll = ({
  options,
  selectedOptions,
  onChange: mainOnChange,
  showValue,
  labelWidth,
  ...extraProps
}) => {
  const classes = useStyles({ width: extraProps.width, labelWidth });

  const optionsMultiSelect = useMemo(
    () => [
      { label: 'All', value: '*' },
      ...[
        ...(_isArray(selectedOptions) ? selectedOptions.filter((i) => i?.value !== '*') : []),
        ...(_isArray(selectedOptions)
          ? options?.filter((i) => !selectedOptions.map((j) => j?.value).includes(i?.value)) || []
          : options),
      ],
    ],
    [options, selectedOptions],
  );

  function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (value && value.some((o) => o.value === '*')) {
      return `${placeholderButtonLabel}: All`;
    }
    return `${placeholderButtonLabel}: ${value?.length || 0} selected`;
  }

  function onChange(value, event) {
    if (event.option?.isDisable) {
      ErrorToast(event.option?.msg);
    } else if (event.action === 'select-option' && event.option.value === '*') {
      this.setState(this.options);
    } else if (event.action === 'deselect-option' && event.option.value === '*') {
      this.setState([]);
    } else if (event.action === 'deselect-option') {
      this.setState(value.filter((o) => o.value !== '*'));
    } else if (value.length === this.options.length - 1) {
      this.setState(this.options);
    } else {
      this.setState(value);
    }
  }

  const formatOptionLabel = ({ label, value, isDisable }) => (
    <span
      style={{
        display: 'inline-block',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: 'black',
        }}
      >
        <div className={classes.ellipsisMessage} style={isDisable ? { opacity: '0.4' } : { opacity: '1' }}>
          {label}
        </div>
        {showValue ? <div>{value === '*' ? 'ID' : value}</div> : null}
      </div>
    </span>
  );

  return (
    <ReactMultiSelectCheckboxes
      options={optionsMultiSelect}
      // eslint-disable-next-line react/jsx-no-bind
      getDropdownButtonLabel={getDropdownButtonLabel}
      value={
        selectedOptions?.length === optionsMultiSelect.length - 1
          ? [{ label: 'All', value: '*' }, ...(selectedOptions || [])]
          : selectedOptions
      }
      // eslint-disable-next-line react/jsx-no-bind
      onChange={onChange}
      setState={mainOnChange}
      formatOptionLabel={formatOptionLabel}
      styles={{
        control: (provided) => ({
          ...provided,
          width: extraProps.width || '100%',
          backgroundColor: '#f4f4f4',
          border: '1px solid rgba(228, 231, 236, 1)',
          borderRadius: '8px',
          fontFamily: 'Lato',
          fontSize: '12px',
          fontWeight: 500,
          color: '#1D2939',
          height: '33px',
          minHeight: '33px',
          padding: '0px 8px',
        }),
        menu: (provided) => ({
          ...provided,
          width: extraProps.width || '100%',
        }),
        dropdownButton: (baseProvided) => ({
          ...baseProvided,
          backgroundColor: '#f4f4f4',
          border: 'none',
          fontFamily: 'Lato',
          fontSize: '12px',
          fontWeight: 500,
          color: '#1D2939',
        }),
        option: (provided, state) => ({
          ...provided,
          fontFamily: 'Lato',
          fontSize: '12px',
          fontWeight: 500,
          opacity: state.isDisabled ? 0.4 : 1,
        }),
        multiValue: (provided) => ({
          ...provided,
          backgroundColor: '#EDEBFE',
          borderRadius: '6px',
          padding: '2px 4px',
          fontSize: '12px',
          fontFamily: 'Lato',
        }),
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...extraProps}
    />
  );
};

export default CustomMultiSelectAll;
